// extracted by mini-css-extract-plugin
export var header = "styles-module--header--43fa4";
export var headline = "styles-module--headline--55e92";